import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Navbar from './Navbar';
import './Problems.css';
import { auth, database } from './firebase';
import './Algorithms.css'
import logo from './images/semicolon.png'

function Problems() {
  const [loggedIn, setLoggedIn] = useState(false);
  const navigate = useNavigate();
  const [userQuestions, setUserQuestions] = useState([]);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setLoggedIn(true);
        fetchUserQuestions(user.uid);
      } else {
        setLoggedIn(false);
      }
    });

    return unsubscribe()
  }, [auth]);

  const fetchUserQuestions = (userId) => {
    const userRef = database.ref('users').child(userId).child('questions');
    userRef.on('value', (snapshot) => {
      const questionsData = snapshot.val();
      if (questionsData) {
        const questionsArray = Object.values(questionsData);
        setUserQuestions(questionsArray);
      }
    });
  };

  return (
    <div className="problems-container">
      <Navbar />
      <div className='logo-container'>
        <Link to='/'>
        <img src={logo} className='logo' alt='logo' />
        </Link>
      </div>
      <div className='message'>
        <h1>
          SORRY !
        </h1>
        <p>
        Dear mobile user, we know you like convenience, but trust us when we say the desktop experience of this web app will blow your tiny mobile mind. Don't settle for less switch to desktop view and unleash your awesome powers!
        </p>
      </div>
      {loggedIn ? (
      <div className="problem">       
          <div className="problem-types">
            <Link to="/problems/algorithms" className="link-style">
              <p>Algorithms</p>
            </Link>
            <Link to="/problems/ds" className="link-style">
              <p>Data Structures</p>
            </Link>
            <Link to="/problems/string" className="link-style">
              <p>String Manipulation</p>
            </Link>
            <Link to="/problems/oop" className="link-style">
              <p>OOP</p>
            </Link>
            {/* <Link to="/problems/puzzles" className="link-style">
              <p>Puzzles</p>
            </Link> */}
          </div>   
          <div className='random'> 
            <div className='algo_tb'>
                <p>Problem</p>
                <p>Difficulty</p>
            </div>
            <div className='prob_diff'>
                <div className='algorithms'>
                    <Link to='/problems/bst-valid' className='link-style'>
                      <p className={`link-style ${userQuestions.find((question) => question.title === 'Binary Search Tree Validation') ? 'submitted' : ''}`}>Binary Search Tree Validation</p>
                    </Link>
                    <Link to='/problems/rmv-duplicates' className='link-style'>
                      <p className={`link-style ${userQuestions.find((question) => question.title === 'Remove Duplicates') ? 'submitted' : ''}`}>Remove Duplicates</p>
                    </Link>
                    <Link to='/problems/palindrome' className='link-style'>
                      <p className={`link-style ${userQuestions.find((question) => question.title === 'Palindrome Check') ? 'submitted' : ''}`}>Palindrome Check</p>
                    </Link>
                    <Link to='/problems/student' className='link-style'>
                      <p className={`link-style ${userQuestions.find((question) => question.title === 'Create a Class for Student') ? 'submitted' : ''}`}>Create a Class for Student</p>
                    </Link>
                    <Link to='/problems/counting' className='link-style'>
                      <p className={`link-style ${userQuestions.find((question) => question.title === 'Counting Elements') ? 'submitted' : ''}`}>Counting Elements</p>
                    </Link>
                    <Link to='/problems/heap-sort' className='link-style'>
                      <p className={`link-style ${userQuestions.find((question) => question.title === 'Heap Sort') ? 'submitted' : ''}`}>Heap Sort</p>
                    </Link>
                    <Link to='/problems/merge-intervals' className='link-style'>
                      <p className={`link-style ${userQuestions.find((question) => question.title === 'Merge Intervals') ? 'submitted' : ''}`}>Merge Intervals</p>
                    </Link>
                    <Link to='/problems/re-matching' className='link-style'>
                      <p className={`link-style ${userQuestions.find((question) => question.title === 'Regular Expression Matching') ? 'submitted' : ''}`}>Regular Expression Matching</p>
                    </Link>
                    <Link to='/problems/sudoku' className='link-style'>
                      <p className={`link-style ${userQuestions.find((question) => question.title === 'Sudoku Solver') ? 'submitted' : ''}`}>Sudoku Solver</p>
                    </Link>
                    <Link to='/problems/online-shopping' className='link-style'>
                      <p className={`link-style ${userQuestions.find((question) => question.title === 'Create a Class for Online Shopping System') ? 'submitted' : ''}`}>Create a Class for Online Shopping System</p>
                    </Link>
                </div>
                <div className='diff'>
                    <p>Easy</p>
                    <p>Easy</p>
                    <p>Easy</p>
                    <p>Easy</p>
                    <p>Easy</p>
                    <p>Medium</p>
                    <p>Medium</p>
                    <p>Medium</p>
                    <p>Hard</p>
                    <p>Hard</p>
                </div>
                </div>
            </div> 
      </div>
      ) : (
        <div>
          <h2>Please sign up/login to see this page</h2>
        </div>
      )}
    </div>
  );
}

export default Problems;
